import { CallEvent } from '../types';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import IWebPhoneService from '../IWebPhoneService';
import appManager from '@app/appManager';
import IAppLogger from '@app/lib/IAppLogger';
import { cacheCall } from '../lib/calls';

const handleCallPlaced = (
  webPhoneService: IWebPhoneService,
  newCallEvent: CallEvent,

  logger: IAppLogger,
) => {
  logger.info(
    `Call in progress: ${newCallEvent.remoteIdentity}, ${newCallEvent.callId}`,
    newCallEvent,
    webPhoneService,
  );

  appManager.events.emit('phone.call.placed', newCallEvent);

  // cache the recently created call
  if (FeatureFlagModule.isEnabled(FeatureFlagKeys.fixOutboundCallerIdErrors)) {
    cacheCall({
      callId: newCallEvent.callId,
      orientation: newCallEvent.direction,
      timestamp: new Date().toISOString(),
    });
  }
};

export default handleCallPlaced;
